import { lazy } from "react";

const edit = lazy(() => import("./Edit").then(m => ({ default: m.AumEntryEdit })));
const list = lazy(() => import("./List").then(m => ({ default: m.AumList })));

export default { edit, list };
